import { FormattedMessage } from "react-intl";
import React from "react";

import { isEnterPressed, isSpacebarPressed } from "@sportal/cdk/helpers";
import { Icon } from "../../../../components/icon/Icon";

import "./ImageUploadField.scss";

export const ImageUploadField = ({
  openUpload,
}: {
  openUpload: () => void;
}) => {
  const spaceAndEnterHandler = (e) => {
    if (isSpacebarPressed(e)) {
      e.preventDefault(); // prevents page scrolling
      openUpload();
    }

    if (isEnterPressed(e)) {
      openUpload();
    }
  };

  return (
    <div>
      <div
        className="image-upload-field"
        data-testid="upload-file-label"
        role="button"
        onKeyDown={spaceAndEnterHandler}
        onClick={openUpload}
        tabIndex={0}
        aria-describedby="image-upload-legend"
      >
        <Icon icon="fa-regular fa-upload image-upload-field__icon" />
        <p className="image-upload-field__text">
          <FormattedMessage id="upload_image" />
        </p>
      </div>
    </div>
  );
};
